<template>
  <div class="inventory-wrapper">
    <v-toolbar
      flat
    >
      <v-toolbar-title>{{ $t('administration.serviceProviderBilling') }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <div>
      <v-skeleton-loader
        v-if="loading"
        class="m-auto"
        type="table"
        transition="scale-transition"
      />
      <VTableRemote
        v-else
        :items="displayedUsers"
        :headers="tableHeaders"
        :sortableColumns="sortableColumns"
        :disablePagination="true"
        :pagination="pagination"
        :isCustomIcon="true"
        :isInfinitScroll="true"
        showExpand
        isSearchable
        hideDefaultFooter
        @sendQueryParams="fetchQuery"
      >
        <template #expanded-item="props">
          <td :colspan="props.headers.length">
            <ServiceProviderBillingDetails
              :teamId="props.item.id"
            />
          </td>
        </template>
        <template #withInfiniteScroll>
          <div v-intersect="endIntersect" />
        </template>
      </VTableRemote>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTableRemote from '@/components/shared/content-views/VTableRemote';
import perpage from '@/constants/pagination';
import ServiceProviderBillingDetails from './ServiceProviderBillingDetails.vue';

export default {
    components: {
        VTableRemote,
        ServiceProviderBillingDetails,
    },
    data() {
        return {
            updatedData: null,
            clientStatus: null,
            teams: [],
            loading: false,
            queryParams: { page: 1, perpage },
            pagination: {},
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'hasPermission',
            'hasRole',
        ]),
        tableHeaders() {
            return [
                {
                    text: this.$t('forms.labels.serviceProvider'),
                    value: 'name',
                    sortable: true,
                },
                {
                    text: this.$t('forms.labels.numberUser'),
                    value: 'totalUsers',
                    sortable: false,
                },
                {
                    text: '',
                    value: '',
                    sortable: false,
                },
                {
                    text: '',
                    value: '',
                    sortable: false,
                },
            ];
        },
        sortableColumns() {
            return this.tableHeaders
                .filter(column => column.sortable)
                .map(column => this.$options.filters.lowercase(column.value));
        },
        displayedUsers() {
            return this.teams;
        },
    },
    async created() {
        this.loading = true;
        await this.getTeams();
        this.loading = false;
    },
    methods: {
        async fetchQuery(queryParams) {
            this.teams = [];
            this.queryParams = { ...this.queryParams, ...queryParams };
            await this.getTeams();
        },
        async getTeams() {
            const { data } = await this.$rq.getTeamsAndUsersCount({
                page: this.queryParams.page || 1,
                perpage: this.queryParams.perpage || 25,
                search: this.queryParams.search,
                order: this.queryParams.order,
            });
            this.teams = [...this.teams, ...data.teams];
            this.pagination = data.pagination;
            this.queryParams = { ...this.queryParams, ...data.pagination };
        },
        async endIntersect(_, __, isIntersecting) {
            const condition = this.queryParams.currentPage < this.queryParams.totalPageCount;
            if (isIntersecting && condition) {
                this.queryParams.page = this.queryParams.currentPage + 1;
                await this.getTeams();
                // access "v-tableRemote" ref
                const ref = this.$refs?.tableRemoteRef?.$refs?.tableRemote;
                if (ref?.onScroll) {
                // workaround to refresh list after adding new items.
                    ref.onScroll();
                }
            }
        },
    },
};
</script>
